import {
  appBridgeBootstrapSchema,
  createAppBridgeClient,
  type AppBridgeClient,
  type AppBridgeContext,
} from "@crewfsm/app-bridge";

export interface QuickBooksAppSession {
  bridge: AppBridgeClient;
  context: AppBridgeContext;
}

export async function connectQuickBooksApp(): Promise<QuickBooksAppSession> {
  if (window.parent === window) {
    throw new Error("Open QuickBooks Online from the CrewFSM Apps navigation.");
  }
  const bootstrap = parseBootstrap(window.name);
  const bridge = createAppBridgeClient({
    installationId: bootstrap.installationId,
    hostOrigin: parseHostOrigin(document.referrer),
    eventSource: window,
    hostWindow: window.parent,
    expectedHostWindow: window.parent,
    currentRoute: window.location.pathname || "/overview",
    clientVersion: "1.0.0",
  });
  try {
    const context = await bridge.connect();
    return { bridge, context };
  } catch (error) {
    bridge.destroy();
    throw error;
  }
}

function parseBootstrap(value: string) {
  try {
    return appBridgeBootstrapSchema.parse(JSON.parse(value));
  } catch {
    throw new Error("CrewFSM did not provide a valid app session bootstrap.");
  }
}

function parseHostOrigin(referrer: string): string {
  try {
    return new URL(referrer).origin;
  } catch {
    throw new Error("CrewFSM host origin is unavailable.");
  }
}
